import { useSmartQuery, useSmartMutation } from "@shared/api/queries/hooks";
import { billsApi } from "./api";
import { PaymentAgreementParams, PaymentListParams, CreditNoteListParams, CombinedBillsServicesParams, PendingConsumerBillsParams, CreditNoteDetailParams, PaymentDetailParams } from "./types";

export const usePaymentAgreementDetail = (params: PaymentAgreementParams) => {
  return useSmartQuery(
    ["consumerWeb", "paymentAgreementDetail", params],
    () => billsApi.getPaymentAgreementDetail(params),
    {
      enabled: !!params.remote_utility_id && !!params.consumer_id,
    }
  );
};

export const usePaymentList = (params: PaymentListParams) => {
  return useSmartQuery(
    ["consumerWeb", "paymentList", params],
    () => billsApi.getPaymentList(params),
    {
      enabled: !!params.remote_utility_id && !!params.consumer_id,
    }
  );
};

export const useCreditNoteList = (params: CreditNoteListParams) => {
  return useSmartQuery(
    ["consumerWeb", "creditNoteList", params],
    () => billsApi.getCreditNoteList(params),
    {
      enabled: !!params.remote_utility_id && !!params.consumer_id,
    }
  );
};

export const usePaymentServices = (params: {
  remote_utility_id: string;
  consumer_id: string;
}) => {
  return useSmartQuery(
    ["consumerWeb", "paymentServices", params],
    () => billsApi.getPaymentServices(params),
    {
      enabled: !!params.remote_utility_id && !!params.consumer_id,
    }
  );
};

export const useCombinedBillsServices = (params: CombinedBillsServicesParams) => {
  return useSmartQuery(
    ["consumerWeb", "combinedBillsServices", params],
    () => billsApi.getCombinedBillsServices(params),
    {
      enabled: !!params.remote_utility_id && !!params.consumer_number,
    }
  );
};

export const usePendingConsumerBills = (params: PendingConsumerBillsParams) => {
  return useSmartQuery(
    ["cx", "pendingConsumerBills", params],
    () => billsApi.getPendingConsumerBills(params),
    {
      enabled: !!params.remote_utility_id && !!params.consumer_id,
    }
  );
};

export const useCreditNoteDetail = (params: CreditNoteDetailParams) => {
  return useSmartQuery(
    ["cx", "creditNoteDetail", params],
    () => billsApi.getCreditNoteDetail(params),
    {
      enabled: !!params.credit_note_id && !!params.remote_utility_id,
    }
  );
};

export const usePaymentDetail = (params: PaymentDetailParams) => {
  return useSmartQuery(
    ["cx", "paymentDetail", params],
    () => billsApi.getPaymentDetail(params),
    {
      enabled: !!params.payment_id && !!params.remote_utility_id,
    }
  );
};
